import { render, staticRenderFns } from "./functionWidge.vue?vue&type=template&id=4db2d6fd&scoped=true"
import script from "./functionWidge.vue?vue&type=script&lang=js"
export * from "./functionWidge.vue?vue&type=script&lang=js"
import style0 from "./functionWidge.vue?vue&type=style&index=0&id=4db2d6fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db2d6fd",
  null
  
)

export default component.exports